window.tinymce.PluginManager.add('formula_picker', function(editor) {
    editor.addButton('formula_picker', () => {
        function showDialog() {
            editor.windowManager.open({
                title: 'Insert Formula',
                width: 734,
                height: 600,
                file: window.hashed_paths['tinymce_formula.html'],
                buttons: [],
            });
        }

        return {
            tooltip: 'Formulas',
            icon: 'custom fa-calculator',
            onclick: showDialog,
        };
    });
});
